module.exports = {
  name(cod) {
    const names = {
      material_type              : 'Material Type',
      finish_plating             : 'Finish Plating',
      copper_inners              : 'Inner Copper wt',
      copper_outers              : 'Outer Copper wt',
      solder_color               : 'Solder Mask Color',
      silkscreen_color           : 'Silkscreen Color',
      material_thickness         : 'Board Thickness',
      package                    : 'Packaging',
      has_advanced_specs         : 'Advanced Specs',
      array_up                   : 'Array Up',
      rails_left                 : 'Rails Left',
      rails_top                  : 'Rails Top',
      rails_bottom               : 'Rails Bottom',
      plated_edges               : 'Plated Edges',
      array_x_qty                : 'Array X Qty',
      array_y_qty                : 'Array Y Qty',
      board_width                : 'Board Width',
      scoring                    : 'V-Scoring',
      number_of_countersink_holes: 'Countersink Holes',
      array_x                    : 'Panel Length',
      array_y                    : 'Panel Width',
      has_array                  : 'Panelized',
      number_of_layers           : '# of Layers',
      gold_fingers_booth_side    : 'Gold Fingers',
      part_number                : 'Part Number',
      revision                   : 'Revision',
      array_spacing_x            : 'Array Spacing X',
      array_spacing_y            : 'Array Spacing Y',
      ul                         : 'UL',
      lot_code                   : 'Date Code',
      solder_sides               : 'Solder Side(s)',
      panel_approval             : 'Panel Approval',
      smallest_hole_size_range   : 'Smallest Hole Size',
      silkscreen_sides           : 'Silkscreen Side(s)',
      rails_right                : 'Rails Right',
      is_panelized               : 'Already Repeated',
      board_length               : 'Board Length',
      min_trace_space            : 'Min Trace Space',
      number_of_counterbore_holes: 'Number Counterbore Holes',
      tab_rout                   : 'Tab-Route',
    };

    return names[cod] ? names[cod] : cod;
  },

  value(name, value, options) {
    const values = {
      FR4     : 'FR4 Tg135',
      FR4TG180: 'FR4 Tg180',
      green   : 'Green',
    };

    const yesNoParams = ['has_array', 'is_panelized', 'tab_rout', 'scoring', 'plated_edges', 'ul', 'lot_code', 'panel_approval']


    if (name === 'package') { return this.valuePackage(options); }
    if (yesNoParams.indexOf(name) >= 0) { return this.valueYesNo(value); }
    if (['array_spacing_x', 'array_spacing_y'].indexOf(name) >= 0) { return this.valueNumberZero(value); }
    if (name === 'material_thickness') {
      return `${value}"`
    }

    return values[value] ? values[value] : value;
  },

  valuePackage(options) {
    if (!options) { return ''; }
    // if (options.get('has_array') === '1') {
    //   return `Panels${
    //     options.get('tab_rout') === '1' ? ' (Tab Routed)' : ''
    //   }${options.get('scoring') === '1' ? ' (V-score)' : ''}`;
    // }

    if (options.get('has_array') === '1') {
      if (options.get('tab_rout') === '1') {
        return 'Tab Routed Panels'
      } else if (options.get('scoring') === '1') {
        return 'V-Score Panels'
      }
    }
    return 'Individual Boards'
  },

  valueYesNo(value) {
    if (value === '1') {
      return 'Yes'
    } else if (value === '0') {
      return 'No'
    }
    return value;
    // return value == '1' ? 'Yes' : (value == '0' ? 'No' : value);
  },

  valueNumberZero(value) {
    return value || '0';
  },
};
